import Vue from "vue";

Vue.filter('points', function (value) {
  return parseFloat(value).toLocaleString(
    process.env.VUE_APP_LOCALE,
    {
      style: 'decimal'
    }
  )
})